import { useSelector } from 'react-redux';
import { useAccountDataQuery } from 'queries/account';
import { getCurrentUserProfileState } from '../index';
import { CurrentUserProfileSliceState } from '../slice';

export const useCurrentUserProfile = (): CurrentUserProfileSliceState => {
  const { isLoading } = useAccountDataQuery();

  const state = useSelector(getCurrentUserProfileState);

  return { ...state, loading: isLoading };
};
